import { UUID } from "../generic/uuid";
import { CountryModel, createCountryDtoFromOfferCountryModel } from "./country";
import { RegionDto } from "@vini-wine/core-dtos";

export interface RegionModel extends UUID {
  // transform
  name: string;

  // available includes
  country: CountryModel;
}

export const createRegionDtoFromOfferRegionModel = (
  region: RegionModel,
): RegionDto => {
  return {
    name: region.name,
    country: createCountryDtoFromOfferCountryModel(region.country),
  };
};
